<div class="container-md">
  <div class="form-group">
    <form>
      @if(step === 0){
      <div>
        <div class="row mx-lg-4">
          <div class="col first-step fw-bold">
            <label>1. {{'IDS_USER' | translate}}</label>
          </div>
          <div class="col">
            <label>2. {{ 'IDS_ACCOUNT' | translate }}</label>
          </div>
        </div>
        <h4 class="sign-up-dialog-centered my-4">
          {{'IDS_CREATE_YOUR_ACCOUNT' | translate}}
        </h4>
        <div class="mx-lg-4">
          <label class="fw-bold">{{'IDS_FIRSTNAME' | translate}}</label><br />
          <input
            class="sign-up-dialog-input"
            type="text"
            name="firstName"
            placeholder="{{'IDS_FIRSTNAME' | translate}}"
            [(ngModel)]="userCredentials.firstName"
          />
          @if(isFirstnameEmpty){
          <div class="row pe-3 d-flex justify-content-center">
            <label class="error-label"
              >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
            >
          </div>
          }
          <label class="fw-bold mt-3">{{'IDS_LASTNAME' | translate}}</label
          ><br />
          <input
            class="sign-up-dialog-input"
            type="text"
            name="lastName"
            placeholder="{{'IDS_LASTNAME' | translate}}"
            [(ngModel)]="userCredentials.lastName"
          />
          @if(isLastnameEmpty){
          <div class="row pe-3 d-flex justify-content-center">
            <label class="error-label"
              >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
            >
          </div>
          }
          <label class="fw-bold mt-3" for="email">{{ 'IDS_EMAIL' | translate }}</label
          ><br />
          <input
            class="sign-up-dialog-input"
            type="email"
            name="email"
            id="email"
            placeholder="{{ 'IDS_EMAIL' | translate }}"
            [(ngModel)]="userCredentials.email"
          />
          @if(isEmailInvalid){
          <div class="row pe-3 d-flex justify-content-center">
            <label class="error-label" for="email"
              >{{ 'IDS_EMAIL_NOT_VALID' | translate }}</label
            >
          </div>
          }
          <label class="fw-bold mt-3">{{'IDS_PHONE' | translate}}</label><br />

          <ngx-intl-tel-input
            [cssClass]="'custom'"
            [preferredCountries]="[CountryISO.UnitedStates, CountryISO.UnitedKingdom]"
            [enableAutoCountrySelect]="false"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.Italy"
            [maxLength]="15"
            [phoneValidation]="true"
            name="phone"
            [(ngModel)]="userCredentials.phoneData"
          >
          </ngx-intl-tel-input>

          @if(isPhoneEmpty){
          <div class="row pe-3 d-flex justify-content-center">
            <label class="error-label"
              >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
            >
          </div>
          }
        </div>
        <div
          class="sign-up-dialog-centered mt-3 text-muted"
          [innerHTML]="'IDS_INTRO_POLICY' | translate"
        ></div>
        <div class="d-flex justify-content-center">
          <label class="text-muted label-container">
            <input
              class="input-checkbox"
              type="checkbox"
              checked="checked"
              name="privacy-policy"
              [(ngModel)]="acceptPolicy"
            />
            {{ 'IDS_ACCEPT_POLICY' | translate }}
            <span class="checkmark"></span>
          </label>
        </div>
        @if(policyNotAccepted){
        <div class="d-flex justify-content-center">
          <label class="error-label"
            >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
          >
        </div>
        }
        <div class="d-flex justify-content-center">
          <button
            class="btn-gold fw-bold px-3 text-uppercase"
            type="button"
            (click)="changeStep(1)"
          >
            {{'IDS_CONFIRM' | translate}}
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <label class="sign-up-dialog-centered text-muted"
            >{{'IDS_ALREADY_HAVE_ACCOUNT' | translate}}</label
          >
        </div>
        <div class="d-flex justify-content-center">
          <button type="button" class="newAccount" (click)="changePage()">
            {{'IDS_ENTER_HERE' | translate}}
          </button>
        </div>
      </div>
      }@if(step === 1){
      <div>
        <div class="row mx-lg-4">
          <div class="col">
            <label>1. {{'IDS_USER' | translate}}</label>
          </div>
          <div class="col first-step fw-bold">
            <label>2. {{ 'IDS_ACCOUNT' | translate }}</label>
          </div>
        </div>
        <form #form="ngForm">
          <div class="mx-lg-4 mt-4">
            <label class="fw-bold" for="username"
              >{{'IDS_CHOOSE_USERNAME' | translate}}</label
            ><br />
            <input
              class="sign-up-dialog-input"
              type="text"
              name="username"
              id="username"
              placeholder="{{'IDS_USERNAME' | translate}}"
              [(ngModel)]="userCredentials.username"
            />
            @if(isUsernameEmpty){
            <div class="row pe-3 d-flex justify-content-center">
              <label class="error-label" for="username"
                >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
              >
            </div>
            }
            <label class="fw-bold mt-3" for="password"
              >{{'IDS_INSERT_PASSWORD' | translate}}</label
            ><br />
            <input
              class="sign-up-dialog-input"
              type="password"
              name="password"
              id="password"
              placeholder="{{'IDS_PASSWORD' | translate}}"
              [(ngModel)]="userCredentials.password"
            />
            @if(isPasswordEmpty){
            <div class="row pe-3 d-flex justify-content-center">
              <label class="error-label" for="password"
                >{{ 'IDS_FIELD_REQUIRED' | translate }}</label
              >
            </div>
            }
            <div class="form-group mb-4 mt-3">
              <label class="me-2 fw-bold" for="idCountry"
                >{{'IDS_COUNTRY' | translate}}</label
              >
              <select
                class="option-list"
                name="idCountry"
                [(ngModel)]="userCredentials.idCountry"
              >
                @for (country of publicGenericService.appCountryList; track country){
                <!-- *ngFor="let country of this.publicGenericService.appCountryList;" -->
                <option value="{{country.idCountry}}">
                  {{ country.niceName }} </option
                >}
              </select>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="btn-gold-radius fw-bold px-3 text-uppercase"
              [disabled]="isProcessing"
              type="button"
              (click)="register(form)"
            >
              {{'IDS_CREATE_ACCOUNT' | translate}}
            </button>
          </div>
        </form>
        <div class="d-flex justify-content-center">
          <button
            class="btn-white-radius fw-bold text-uppercase px-3"
            type="button"
            (click)="changeStep(0)"
          >
            {{'IDS_BACK' | translate}}
          </button>
        </div>
        <div class="d-flex justify-content-center">
          <label class="sign-up-dialog-centered text-muted"
            >{{'IDS_ALREADY_HAVE_ACCOUNT' | translate}}</label
          >
        </div>
        <div class="d-flex justify-content-center">
          <button type="button" class="newAccount" (click)="changePage()">
            {{'IDS_ENTER_HERE' | translate}}
          </button>
        </div>
      </div>
      }@if(step === 2){
      <div>
        <h4 class="sign-up-dialog-centered my-4">
          @if(!userCredentials.activeWithSMS){ {{'IDS_WELCOME' | translate}} {{
          userRegistration.username }}! } @else { {{'IDS_CHECK_LINK_SMS' |
          translate}} }
        </h4>
        @if(!userCredentials.activeWithSMS){
        <div class="mx-lg-4">
          <p class="text-muted">{{'IDS_THANKS_REGISTER' | translate}}</p>
          <p class="text-muted">
            {{ (userCredentials.activeWithSMS ? 'IDS_CHECK_LINK_SMS' :
            'IDS_CHECK_LINK') | translate}}
          </p>
          <p class="text-muted">
            {{ (userCredentials.activeWithSMS ? 'IDS_CHECK_SPAM_SMS' :
            'IDS_CHECK_SPAM') | translate}}
          </p>
        </div>
        }
      </div>
      }
    </form>
  </div>
</div>
